function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  strokeWidth: "1px",
  stroke: "#9966ff",
  transform: "translate(100, 0)",
  points: "1284.4,1104.8 1510.4,539.1 1268.8,687.8 1585.4,0.4 509.3,901.4 701.5,313.6 0.4,1104.8",
  className: "jsx-1705053520"
});

var SvgBolt = function SvgBolt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1585.9 1105.1",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      height: "110vh",
      width: "100vw",
      opacity: 1,
      strokeDasharray: 4729,
      strokeDashoffset: 9458
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBolt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bolt.43c0eab8.svg";
export { ForwardRef as ReactComponent };